import React from 'react';
import SelectShops from './SelectShops';

import { IonHeader, IonToolbar, IonImg, IonGrid, IonRow, IonCol } from '@ionic/react';
import HeaderButtons from '../HeaderButtons';

const HomeHeader = ({ options, selected, saveShop, shops, slot, history, fpsConfigs }) => {
  return (
    <IonHeader>
      <IonToolbar>
        {fpsConfigs?.products > 0 && options?.buy_products_in_app === '1' && (
          <HeaderButtons slot={slot} history={history} />
        )}

        <IonGrid>
          <IonRow>
            <IonCol size="7">
              <IonImg
                src={`${process.env.REACT_APP_API_URL}/logo/logo.png`}
                alt={options?.shop_name}
                style={{ maxWidth: '200px' }}
              />
            </IonCol>

            <IonCol size="5">
              {shops?.length > 1 && <SelectShops selected={selected} saveShop={saveShop} shops={shops} />}
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonToolbar>
    </IonHeader>
  );
};

export default HomeHeader;
